export const SITE_REDIRECT_MAPPING_KEY = 'Global_OldToNewSite_Redirect_Mapping';

export interface SiteRedirectMapping {
  oldHost: string;
  newHost: string;
}

export interface LocationParts {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}

const HOST_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/;

function normalizeHost(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/+$/, '');
}

/**
 * Parses the CMS value `olddomain|newdomain`. Returns null unless it holds exactly two
 * distinct, plain hostnames — anything else (blank, no `|`, a path, a port) means "no redirect".
 */
export function parseSiteRedirectMapping(value: string | null | undefined): SiteRedirectMapping | null {
  if (!value || !value.includes('|')) {
    return null;
  }
  const parts = value.split('|');
  if (parts.length !== 2) {
    return null;
  }
  const oldHost = normalizeHost(parts[0]);
  const newHost = normalizeHost(parts[1]);
  if (!HOST_PATTERN.test(oldHost) || !HOST_PATTERN.test(newHost) || oldHost === newHost) {
    return null;
  }
  return { oldHost, newHost };
}

/**
 * The https URL to send the browser to, or null when the current host isn't the mapped old host.
 * Path, query string and fragment are carried over so deep links survive the move.
 */
export function resolveSiteRedirectUrl(mapping: SiteRedirectMapping | null, location: LocationParts): string | null {
  if (!mapping || location.hostname.toLowerCase() !== mapping.oldHost) {
    return null;
  }
  return `https://${mapping.newHost}${location.pathname}${location.search}${location.hash}`;
}
